module.exports = __webpack_public_path__ + "img/fgs-037-148.3dd56bac.jpg";